import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../../chunks/tslib.es6.js";
import { IdentifiableMixin as o } from "../../core/Identifiable.js";
import { JSONSupport as e } from "../../core/JSONSupport.js";
import { property as s } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as r } from "../../core/accessorSupport/decorators/subclass.js";

var p = /*#__PURE__*/function (_o) {
  _inherits(p, _o);

  var _super = _createSuper(p);

  function p(t) {
    var _this;

    _classCallCheck(this, p);

    _this = _super.call(this, t), _this.autoNavigate = null, _this.filter = null, _this.getResults = null, _this.getSuggestions = null, _this.maxResults = null, _this.maxSuggestions = null, _this.minSuggestCharacters = null, _this.outFields = null, _this.placeholder = "", _this.popupEnabled = null, _this.popupTemplate = null, _this.prefix = "", _this.resultGraphicEnabled = null, _this.resultSymbol = null, _this.suggestionsEnabled = null, _this.suffix = "", _this.withinViewEnabled = !1, _this.zoomScale = null;
    return _this;
  }

  return p;
}(o(e));

t([s()], p.prototype, "autoNavigate", void 0), t([s()], p.prototype, "filter", void 0), t([s()], p.prototype, "getResults", void 0), t([s()], p.prototype, "getSuggestions", void 0), t([s()], p.prototype, "maxResults", void 0), t([s()], p.prototype, "maxSuggestions", void 0), t([s()], p.prototype, "minSuggestCharacters", void 0), t([s()], p.prototype, "outFields", void 0), t([s()], p.prototype, "placeholder", void 0), t([s()], p.prototype, "popupEnabled", void 0), t([s()], p.prototype, "popupTemplate", void 0), t([s()], p.prototype, "prefix", void 0), t([s()], p.prototype, "resultGraphicEnabled", void 0), t([s()], p.prototype, "resultSymbol", void 0), t([s()], p.prototype, "suggestionsEnabled", void 0), t([s()], p.prototype, "suffix", void 0), t([s()], p.prototype, "withinViewEnabled", void 0), t([s()], p.prototype, "zoomScale", void 0), p = t([r("esri.widgets.Search.SearchSource")], p);
var i = p;
export { i as default };